import { Outlet } from 'react-router-dom'

const HyundaiCarModel = () => <Outlet />

export default HyundaiCarModel
